import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./step-check.svg?react";

export const StepCheckIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
